import React from 'react'
import PropTypes from 'prop-types'

import { graphql } from 'react-apollo'
import loadFooterContent from './loadFooterContent.gql'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toggleTermsAndConditions } from '../../store/actions'
import { removeEmptyValues } from '../../utils'
import loadable from '@loadable/component'

import Loading from '../../components/pages/Loading'
const Footer = loadable(() => import('@albatross/common-components/dist/components/Footer/Footer'))

function FooterContainer (props) {
  const {
    data,
    customTermsAndConditions,
    termsAndConditionsOpen,
    toggleTermsAndConditions,
    pageFooterOverride,
    venture,
    enableContentful,
    provider
  } = props

  if (data.loading) {
    return <Loading />
  }
  if (data.error) {
    return data.error
  }

  const { providers = [], contentfulFooter } = data

  let footerProps = enableContentful
    ? {
        ...contentfulFooter,
        welcomeBonusTnc: {
          showWelcomeBonusTnC: pageFooterOverride?.welcomeBonusTermsAndConditionsLong?.trim()?.length || contentfulFooter?.welcomeBonusTermsAndConditionsLong?.trim()?.length,
          welcomeBonusTnCHeading: (pageFooterOverride?.welcomeBonusTnCHeading ?? contentfulFooter?.welcomeBonusTnCHeading)?.trim()
        }
      }
    : data?.globalContent?.globalFooter

  const lang = data?.globalContent?.lang
  if (pageFooterOverride?.enabled) {
    footerProps = { ...footerProps, ...removeEmptyValues(pageFooterOverride) }
  }

  const {
    footerContent,
    primaryIcons,
    secondaryIcons = [],
    footerLinks,
    welcomeBonusTermsAndConditionsLong,
    welcomeBonusTnc = {}
  } = footerProps

  const termsAndConditionsData =
    customTermsAndConditions && customTermsAndConditions !== '<p><br></p>'
      ? customTermsAndConditions
      : welcomeBonusTermsAndConditionsLong

  return (
    <Footer
      // Custom Terms and Condition
      welcomeBonusTermsAndConditionsLong={termsAndConditionsData}
      providers={providers}
      // Footer Content is Legal Info
      footerContent={footerContent}
      termsAndConditionsOpen={termsAndConditionsOpen}
      toggleTermsAndConditions={toggleTermsAndConditions}
      primaryIcons={primaryIcons ?? []}
      secondaryIcons={secondaryIcons ?? []}
      links={footerLinks ?? []}
      venture={venture}
      welcomeBonusTnc={welcomeBonusTnc}
      lang={lang ?? ''}
      provider={provider}
    />
  )
}

FooterContainer.propTypes = {
  data: PropTypes.object,
  customTermsAndConditions: PropTypes.string,
  termsAndConditionsOpen: PropTypes.bool,
  toggleTermsAndConditions: PropTypes.func,
  venture: PropTypes.string,
  pageFooterOverride: PropTypes.object,
  enableContentful: PropTypes.bool,
  provider: PropTypes.object
}

function mapStateToProps (state) {
  return {
    termsAndConditionsOpen: state.termsAndConditionsOpen,
    gamesLegalLines: state.gamesLegalLines
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ toggleTermsAndConditions }, dispatch)
}

const FooterContainerWithData = graphql(loadFooterContent, {
  options: props => {
    return ({
      variables: {
        providers: props.gamesLegalLines,
        enableContentful: props?.enableContentful ?? false
      }
    })
  }
})(FooterContainer)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterContainerWithData)
